import React from 'react'
import { Helmet } from 'react-helmet'
import HeroSection from '../pages/SucessStories/HeroSection'
import Section3DM from '../pages/products-pages/Section3DM'
import Section6 from '../pages/homepage/Section6'

const DisputeCal = () => {
  return (
    <div>
        <Helmet style={{ backgroundColor: '#fff' }}>
            <title>Voosh Dispute Resolution ROI</title>
            <meta name='description' content="Voosh's Dispute Resolution" />
            <meta name='keywords' content='Voosh Solutions, Voosh Features, Restaurant Technology, 3rd Party Marketplace Management, Data-Driven Decisions, Restaurant Operations, Restaurant Profitability' />
      </Helmet>
      <HeroSection contents={{ head: 'Voosh Dispute Resolution ROI', s_head: '' }} />
      <Section3DM />
      <Section6 />
    </div>
  )
}

export default DisputeCal